































import { Component, Prop, Mixins } from "vue-property-decorator";

import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";

@Component
export default class AdminOrders extends Mixins(RequestPromises) {
  // Props
  @Prop({ default: () => () => [] })
  public routes!: () => any;
  // Data
  public isLoading = false;
  public totalOrders = 0;
  // Getters
  public get i18n() {
    return {
      add_order: this.$t("_action.add_object", {
        object: (this.$t("_.order") as string).toLowerCase()
      }),
      add_your_first_order: this.$t("_.add_your_first_object", {
        object: (this.$t("_.order") as string).toLowerCase()
      })
    };
  }
  public get canAddOrder() {
    // list_clients because a client must be selected
    return this.$userCan("staff_create_order", "list_clients");
  }
  // Methods
  public created() {
    this.isLoading = true;
    this.$store
      .dispatch(`data/${DataModules.CONTRACTS}/list`, {
        vm: this,
        scope: "count",
        returnData: false,
        storeData: false,
        params: {
          limit: "count"
        }
      })
      .then(result => {
        this.totalOrders = result.total;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
